import React, { useEffect } from "react";
import axios from "axios";
import { environmentVar }  from "../../config/environmentVar.js";

const DynamicFavicon = () => {
  useEffect(() => {
    const fetchFavicon = async () => {
      try {
        const res = await axios.get(
          `${environmentVar.apiUrl}/api/admin/settings/favicon`,
          { withCredentials: true }
        );

        if (res?.data?.success && res?.data?.setting?.setting_value) {
          const faviconUrl = `${environmentVar.apiUrl}/${res.data.setting.setting_value}`;

          // Check if a <link rel="icon"> already exists
          let link = document.querySelector("link[rel*='icon']");
          if (link) {
            link.href = faviconUrl; // just update href
          } else {
            // create new link if not exists
            link = document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = faviconUrl;
            document.head.appendChild(link);
          }
        }
      } catch (err) {
        console.error("Failed to load favicon:", err);
      }
    };

    fetchFavicon();
  }, []);

  return null;
};

export default DynamicFavicon;
